import { SettlementSummaryReport } from "@/components/features/reports/Settlements/SettlementSummaryReport";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  settlementSummaryQueryOptions,
  useUpdateSettlementReportDefaultRole,
} from "@/lib/data/react-query/reports/reports-settlement-summary";
import {
  hasValidSettlementDates,
  type SettlementSummaryFilters,
} from "@/lib/data/requests/reports/reports-settlement-summary";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { format, subDays } from "date-fns";
import { useState } from "react";

export const Route = createFileRoute("/_auth/reports/settlement-summary")({
  component: RouteComponent,
});
function defaultFilters(): SettlementSummaryFilters {
  const now = new Date();
  return {
    startDate: format(subDays(now, 6), "yyyy-MM-dd"),
    endDate: format(now, "yyyy-MM-dd"),
    page: 1,
    pageSize: 50,
  };
}
function RouteComponent() {
  const { hasPagePermission } = useUser();
  const canView = hasPagePermission(
    PAGE_PERMISSION_KEYS.mattersReportsSettlements,
  );
  const [filters, setFilters] = useState(defaultFilters);
  const query = useQuery({
    ...settlementSummaryQueryOptions(filters),
    enabled: canView && hasValidSettlementDates(filters),
  });
  const pin = useUpdateSettlementReportDefaultRole();
  if (!canView) return <GlobalNotAuthorized />;
  return (
    <SettlementSummaryReport
      filters={filters}
      report={query.data}
      isLoading={query.isLoading}
      isFetching={query.isFetching}
      isError={query.isError}
      isPinning={pin.isPending}
      onPinRole={(roleId) => {
        const data = query.data?.data;
        if (
          data?.pinnedRoleId === undefined ||
          data.firmDateModified === undefined
        )
          return;
        pin.mutate({
          roleId,
          expectedPinnedRoleId: data.pinnedRoleId,
          firmDateModified: data.firmDateModified,
        });
      }}
      onFilters={setFilters}
      onReset={() => {
        setFilters(defaultFilters());
      }}
      onRetry={() => {
        void query.refetch();
      }}
    />
  );
}
